import { type Country, type FormComponentMappingType, type WalletCurrencySchemaType } from '@capsicum/common';

import {
	AmountInput,
	CheckboxInput,
	CodeInput,
	CountrySelectInput,
	CurrencySelect,
	DateInput,
	FileInput,
	QuantityInput,
	RadioGroupInput,
	SearchInput,
	SelectInput,
	TextInput,
	ToggleInput
} from '../molecules/form';
import { AmountSelectionInput } from '../molecules/form/amount-selection-input/AmountSelectionInput';

const componentMapping: FormComponentMappingType = {
	amount: { component: AmountInput, props: {} },
	amountSelection: { component: AmountSelectionInput, props: {} },
	checkbox: { component: CheckboxInput, props: {} },
	code: { component: CodeInput, props: {} },
	country: {
		component: CountrySelectInput,
		props: {
			itemTemplate: ({ item }: { item: Country }) => `${item.name} - ${item.name}`,
			labelProp: 'name',
			withSearch: true
		}
	},
	currency: {
		component: CurrencySelect,
		props: {
			emptyListMessage: 'No results',
			itemTemplate: ({ item }: { item: WalletCurrencySchemaType }) => `${item.shortCode} - ${item.label}`,
			withSearch: true
		}
	},
	dateOfBirth: { component: DateInput, props: {} },
	file: { component: FileInput, props: {} },
	quantity: { component: QuantityInput, props: {} },
	radioGroup: { component: RadioGroupInput, props: {} },
	search: { component: SearchInput, props: {} },
	select: {
		component: SelectInput,
		props: {
			onSearch: (data: Array<string>, text: string) => {
				return data.filter(item => item.includes(text));
			}
		}
	},
	text: { component: TextInput, props: {} },
	toggle: { component: ToggleInput, props: {} }
};

export default componentMapping;
